<template>
  <el-container class="full">
    <el-aside class="logo-column">
      <span class="left-panel">
        <el-row>
          <img src="@/assets/HAH_LOGO_V3-02.svg" height="81px">
        </el-row>
      </span>
    </el-aside>
    <el-main v-loading.fullscreen.lock="fullscreenLoading">
      <span class="right-panel">
        <el-row>
          <label class="header gray-text">HAH Web Admin</label>
        </el-row>
        <el-row>
          <label class="gray-text">version: {{ version }}</label>
        </el-row>
        <el-row>
          <el-button type="primary" @click="login">เข้าสู่ระบบ</el-button>
        </el-row>
        <br />
      </span>
    </el-main>
  </el-container>
</template>

<style lang="scss" scoped>
  .header {
    font-family: 'Sukhumvit-SemiBold';
    font-size: 28px;
    font-weight: 400;
    line-height: 1.5;
  }
  .logo-column {
    background: #5489FF;
  }
  .right-panel {
    margin-left: 50%;
    width: 100%;
    position: absolute;
    text-align: center;
  }
  .el-main {
    display: flex;
    align-items: center;
  }
  .left-panel{
    background: #5489FF;
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    justify-content: center;
    align-items: center;
    position: absolute;
    text-align: center;
  }
  .full {
    height: 100%;
    position: absolute;
  }
  .el-aside.logo-column {
    width: 457px !important;
  }
  .gray-text {
    color: #606266;
  }
  .el-button {
    height: 40px;
    width: 300px;
    margin-top: 20px;
  }
</style>

<script>
import { buildVersion } from '@/services/api'

export default {
  name: 'Login',
  data () {
    return {
      fullscreenLoading: false,
    }
  },
  methods: {
    async login () {
      try {
        this.fullscreenLoading = true
        window.location.href = `${process.env.VUE_APP_API_URL}/admin/auth/oauth2/signin?r=${window.location.href}`
      } catch (error) {
        let message = `อุ๊ปส์! ${error.response.data.error}`
        if (error.response.status === 403) {
          message = 'ไม่สามารถเข้าสู่ระบบ กรุณากรอกอีเมลและรหัสผ่านให้ถุกต้อง'
        }
        this.$alert(message, 'เข้าสู่ระบบ', {
          confirmButtonText: 'OK',
          type: 'error',
          showClose: false,
        })
      } finally {
        this.fullscreenLoading = false
      }
    },
  },
  computed: {
    version () {
      return buildVersion()
    },
  },
}
</script>
